<template>
    <div id="EnProgressSearchItem">
        <h2 class="h2 w90-mb" :class="item.status">
            {{ item.products[index].name }}
        </h2>
        <div class="info-wrap w90-mb">
            <aside>
                <div class="status-wrap" :class="item.status">
                    <!-- <p>審查情形</p> -->
                    <div v-if="item.status === 'Valid'">
                        <h3 class="h3">Approval</h3>
                        <p class="p2">agree to use label</p>
                    </div>
                    <div v-else-if="item.status === 'Pending'">
                        <h3 class="h3">Reviewing</h3>
                        <p class="p2">agency's review</p>
                    </div>
                    <div v-else>
                        <h3 class="h3">Reject</h3>
                        <p class="p2">reject application</p>
                    </div>
                </div>
                <ul v-if="item.status === 'Valid'" class="hide info-list">
                    <li class="list-item">
                        <h4 class="head en">Permit document number</h4>
                        <h5 class="body">{{ item.epaPublishNumber }}</h5>
                    </li>
                    <li class="list-item">
                        <h4 class="head en">Period of validity</h4>
                        <h5 class="body">{{ item.validDateRange }}</h5>
                    </li>
                </ul>
            </aside>
            <main>
                <div class="info-list-group">
                    <h3 class="h3 hide">Recycled marine debris product</h3>
                    <ul class="info-list">
                        <li class="list-item">
                            <h4 class="head en">Product name</h4>
                            <h5 class="body">
                                {{ item.products[index].name }}
                            </h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head en">Model no.</h4>
                            <h5 class="body">
                                {{ item.products[index].model }}
                            </h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head en">
                                Weight originating from a marine debris
                            </h4>
                            <h5 class="body">
                                {{ item.products[index].weightRate }}%
                            </h5>
                        </li>
                    </ul>
                </div>
                <div class="info-list-group">
                    <h3 class="h3 hide">Applicant</h3>
                    <ul class="info-list">
                        <li class="list-item">
                            <h4 class="head en">Applicant</h4>
                            <h5 class="body">
                                {{ item.registerInstitution }}
                            </h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head en">Unified business no.</h4>
                            <h5 class="body">{{ item.taxId }}</h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head en">
                                Document issue number (by the applicant)
                            </h4>
                            <h5 class="body">
                                {{ item.unitPublishNumber }}
                            </h5>
                        </li>
                    </ul>
                </div>
                <div
                    v-if="item.status === 'Valid'"
                    class="hide-mb info-list-group"
                >
                    <ul class="info-list">
                        <li class="list-item">
                            <h4 class="head en">Permit document number</h4>
                            <h5 class="body">
                                {{ item.epaPublishNumber }}
                            </h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head en">Period of validity</h4>
                            <h5 class="body">{{ item.validDateRange }}</h5>
                        </li>
                    </ul>
                </div>
            </main>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EnProgressSearchItem',
    props: { item: Object, index: Number },
}
</script>
<style lang="scss" scoped>
#EnProgressSearchItem {
    @media screen and (min-width: 768px) {
        padding: 50px 0;
        border-top: 2px solid $theme0;
        .info-wrap {
            display: flex;
        }
    }
    @media screen and (max-width: 767px) {
        padding: 50px 0 10px;
        margin: 10px 0;
        background-color: $grayF;
    }
}

h2.h2 {
    padding-bottom: 1em;
}
h3.h3 {
    padding-bottom: 0em;
    text-align: center;
}
h2.Invalid {
    color: $gray6;
}
p.p2 {
    text-align: center;
    text-indent: 0;
}
.head.en {
    line-height: 1.2em;
    padding-bottom: 0.3em;
}
aside {
    .status-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &.Valid {
            background-color: $theme3;
            p,
            h3 {
                color: $white;
            }
        }
        &.Pending {
            background-color: $theme0;
            p,
            h3 {
                color: $theme3;
            }
        }
        &.Invalid {
            background-color: $grayB;
            p,
            h3 {
                color: $white;
            }
        }
    }

    @media screen and (min-width: 768px) {
        flex: 0;
        .status-wrap {
            width: 160px;
            height: 160px;
        }
    }
    @media screen and (max-width: 767px) {
        display: flex;
        padding-bottom: 20px;
        .status-wrap {
            width: 120px;
            height: 120px;
        }
    }
}
main {
    @media screen and (min-width: 768px) {
        flex: 1;
        display: flex;
    }
}
.info-list-group {
    @media screen and (min-width: 768px) {
        min-width: 18%;
        padding: 0 5%;
        border-right: 1px solid $grayB;
        &:last-child {
            border-right: none;
        }
    }
    @media screen and (max-width: 767px) {
        border-top: 1px solid $grayB;
        padding: 20px 0;
        display: flex;
        h3 {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 120px;
            color: $gray6;
        }
    }
}
.info-list {
    color: $gray6;
    li {
        margin-bottom: 10px;
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (max-width: 767px) {
        padding: 0 5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}
</style>
